import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Routes } from '@/router';

@Component({
  name: 'CmgAccountModalAccountLinks',
})
export default class CmgAccountModalAccountLinks extends Vue {
  @Prop({ required: false, default: false, type: Boolean })
  shouldShowCountryFlag?: boolean;

  get isOrderingOnline(): boolean {
    return this.$services.utils.isOrderingOnline();
  } 

  onClickFavoriteAndRecentOrders() {
    this.$router.push({ name: Routes.RecentsAndFavorites });
    this.close();
    this.$services.ui.nextFocus('myOrder-title');
  }

  onClickPaymentsAndGiftCards() {
    this.$router.push({ name: Routes.PaymentsAndGiftCards });
    this.close();
    this.$services.ui.nextFocus('payment-title');
  }

  onClickPersonalAndPreferences() {
    this.$router.push({ name: Routes.EditAccount });
    this.close();
    this.$services.ui.nextFocus('personal-preference-txt');
  }

  onClickSavedAddresses() {
    this.$services.ui.setModalVisibility('findAChipotle', true, { mode: 'delivery' });
    this.$services.ui.firstFocus();
    this.$services.ui.setModalVisibility('account', false);
  }

  close() {
    this.$services.ui.setModalVisibility('account', false);
    this.$services.ui.clearLastSelectedElement();
  }
}
